const appLauncher = {
  allApps: "All Apps",
  entities: "Records",
  history: "History",
  records: "Records",
  noRecords: "No records",
  noHistory: "No history",
  openApp: "Open {appName}",
  justNow: "just now",
  minutesAgo: "{minutes}m ago",
  hoursAgo: "{hours}h ago",
  daysAgo: "{days}d ago",
} as const;

export default appLauncher;